import React, { Component } from 'react'
import './ComingSoon.css'

export default class NavBar extends Component {
  render() {
    return (
      <div className='coming-soon'>
        <div className='coming-soon-text'>
          Pre-orders for Project0 and Project1 will be available soon.
        </div>
        <a href='' className='button'>
          Learn more &gt;
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/home/ComingSoon.js